import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=5e666aaf"
import script from "./Friend.vue?vue&type=script&lang=js"
export * from "./Friend.vue?vue&type=script&lang=js"
import style0 from "./Friend.vue?vue&type=style&index=0&id=5e666aaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports